module.exports = __webpack_public_path__ + "static/media/avatar.aa1c3687.jpg";